import React, { useRef, forwardRef } from "react";
import PropTypes from "prop-types";

import { handleKeyDownNavigation } from "../../utils/keyboard-navigation/keyboard-navigation";

import styles from "./SelectBody.module.scss";

const SelectBody = forwardRef(({
  options,
  labels,
  className,
  renderGroup,
  slotsAfterOptions,
}, ref) => {
  const refInternal = useRef(null);
  const refRoot = ref ?? refInternal;

  if (!options) {
    return null;
  }

  const renderOptions = () => {
    if (Array.isArray(options)) {
      const elements = [];

      const renderOptionsGroup = (options, indexGroup, array) => {
        if (!options) {
          return;
        }

        if (options.length || slotsAfterOptions?.[indexGroup]) {
          const label = labels?.[indexGroup];

          elements.push(renderGroup({
            label,
            indexGroup,
            options,
          }));

          if (slotsAfterOptions?.[indexGroup]) {
            elements.push(slotsAfterOptions[indexGroup]);
          }

          if (elements.length && array && array[indexGroup + 1]) {
            elements.push(
              <hr
                key={"divider" + indexGroup}
                className={styles["options-group-divider"]}
              />,
            );
          }
        }
      };

      if (options.length) {
        if (options.some((o) => Array.isArray(o))) {
          options.forEach(renderOptionsGroup);
        } else {
          renderOptionsGroup(options, 0);
        }
      }

      return elements;
    }

    return options;
  };

  const handleItemKeyDown = (e) => handleKeyDownNavigation(refRoot.current, e, true);

  return (
    <div ref={refRoot} className={className} onKeyDown={handleItemKeyDown}>
      {renderOptions()}
    </div>
  );
});

SelectBody.propTypes = {
  className: PropTypes.string,
  options: PropTypes.array,
  labels: PropTypes.array,
  renderGroup: PropTypes.func,
  slotsAfterOptions: PropTypes.array,
};

export default SelectBody;
